import {create} from 'zustand';
import {devtools} from 'zustand/middleware';

type ReportState = {
  hasInlineComments: boolean;
  isSyncingToRedux: boolean;
  setHasInlineComments: (hasComments: boolean) => void;
  setIsSyncingToRedux: (isSyncing: boolean) => void;
};

export const useReportState = create<ReportState>()(
  devtools(
    set => ({
      hasInlineComments: false,
      isSyncingToRedux: false,
      setHasInlineComments: (hasComments: boolean) =>
        set(() => ({hasInlineComments: hasComments})),
      setIsSyncingToRedux: (isSyncing: boolean) => {
        set(() => ({isSyncingToRedux: isSyncing}));
      },
    }),
    {name: 'ReportState'}
  )
);
